import { Injectable } from '@angular/core';
import { Gtp } from '../gtp';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { MovilRecorrido } from 'src/app/models/movil-recorrido.model';
import { MovilMapa } from 'src/app/models/movil-mapa.model';

import { MapToolsService } from '../../shared/services/map-tools.service';
//import { MovilRecorridoResumen } from 'src/app/models/movil-recorrido-resumen.model';
import { MovilRecorridoResumenLista } from 'src/app/models/movil-recorrido-resumen-lista.model';
import { ListaRecorridoPosicionesComponent } from 'src/app/modules/movil/lista-recorrido-posiciones/lista-recorrido-posiciones.component';
import { ListaRecorridoEventosComponent } from 'src/app/modules/movil/lista-recorrido-eventos/lista-recorrido-eventos.component';
import { DatosUtiles } from '../../models/movil-datos-utiles.model';

@Injectable({
  providedIn: 'root'
})
export class ListaMovilesService {

  private markers = new Subject<any>();
  public flotaMoviles = new Subject<any>();
  public resumenRecorrido = new Subject<any>();
  public posRecorrido = new Subject<any>();
  public updateMarkers = new Subject<any>();
  public movilActivo = {
    cod_equipo_rastreo: null,
    fecha_hora: null,
    des_equipo_ratreo: null,
  };
  qs = require('qs');

  public resumenListado:any = [];

  constructor(
    private gtp: Gtp,
    private http: HttpClient,
    private MapToolsService: MapToolsService
  ) {

  }

  getUpdateMarkers(){
    return this.updateMarkers.asObservable();
  }

  setUpdateMarkers(){
    this.updateMarkers.next(true);
  }

  /**
   * Trae la totalidad de moviles con sus características, no trae aspectos de posición/eventos
   */
  getTotalMoviles(total=false){
    var filter = {
      limit: (total) ? 10000 : 10
    }
    let urlFilter = this.qs.stringify(filter);
    const url = `${environment.baseUrl}clientes/vehiculos?` + urlFilter;
    return this.http.get(url);
    //return this.http.post(url, filter);
  }

  /**
   * Trae el listado de móviles con datos de ubicación
   */
  getListaMoviles() {
    let user = JSON.parse(this.gtp.getUserData());
    const url = `${environment.baseUrl}listar/getvehiculos/${user.cod_cliente}`;
    return this.http.get(url);
  }

  /**
   * Observer Movil Activo
   */
  getMovilActivo(){
    let result = JSON.parse(this.gtp.getItemLocalStorage('movilActivo'));
    return result;
  }
  /**
   * Set Movil Activo
   */
  setMovilActivo(obj){
    this.gtp.setItemLocalStorage('movilActivo', obj);
  }

  removeMovilActivo(){
    this.gtp.removeItemLocalStorage('movilActivo');
  }

  /**
   * Agrega markers
   * @param markers
   */
  setMarkers(markers){
    this.markers.next(markers);
  }
  /**
   * Devuelve los markers activos
   */
  getMarkers() {
    return this.markers.asObservable();
  }

  /**
   * Agrega resumen
   * @param resumen
   */
  setResumenRecorrido(resumen){
    this.resumenListado = resumen;
    this.resumenRecorrido.next(resumen);
  }
  /**
   * Devuelve los markers activos
   */
  getResumenRecorrido() {
    return this.resumenRecorrido.asObservable();
  }

  /**
   * Trae la Flota
   * @param markers
   */
  setflotaMoviles(markers){
    this.flotaMoviles.next(markers);
  }
  /**
   * Devuelve los markers activos
   */
  getflotaMoviles() {
    return this.flotaMoviles.asObservable();
  }

  callflotaMoviles(){
    this.getListaMoviles().subscribe((res) => {
      const markersByEquipo = new Map<string, MovilMapa>();
      Object.entries(res).forEach(item => {
        const marker = new MovilMapa(item[1]);
        if (marker.visible !== false) {
          const normalize = (value: any) => String(value ?? '').trim().toUpperCase();
          const invalidPlaceholders = new Set(['', '0', 'PROVISORIO', 'PROVI', 'NULL', 'UNDEFINED', 'N/A', 'NA', '-']);
          const fromCodEquipo = normalize(marker.cod_equipo_rastreo);
          const fromNroVehiculo = normalize(marker.nro_vehiculo);
          const fromMatricula = normalize(marker.matricula);
          const fromDescripcion = normalize(marker.des_equipo_ratreo);
          const fromId = normalize(marker.id);

          const key = !invalidPlaceholders.has(fromCodEquipo)
            ? `COD:${fromCodEquipo}`
            : !invalidPlaceholders.has(fromNroVehiculo)
              ? `NRO:${fromNroVehiculo}`
              : !invalidPlaceholders.has(fromMatricula)
                ? `MAT:${fromMatricula}`
                : !invalidPlaceholders.has(fromDescripcion)
                  ? `DESC:${fromDescripcion}`
                  : !invalidPlaceholders.has(fromId)
                    ? `ID:${fromId}`
                    : '';

          if (!key) {
            return;
          }

          const current = markersByEquipo.get(key);
          if (!current) {
            markersByEquipo.set(key, marker);
            return;
          }

          const currentDate = new Date(current.fecha_hora as any).getTime();
          const nextDate = new Date(marker.fecha_hora as any).getTime();

          if (isNaN(currentDate) || nextDate >= currentDate) {
            markersByEquipo.set(key, marker);
          }
        }
      });
      const markers = Array.from(markersByEquipo.values());

      this.setflotaMoviles(markers);
    });
  }

  /**
   * Trae el recorrido en base a una fecha del móvil solicitado
   */
  getRecorridoMovil(filtro, idequipo) {
    var filter = {
        fecha_hora: {
          between: [filtro.desde, filtro.hasta]
        },
        /* recorrido: {
          pointtype: "UltimoEvento",
          hide: {
            geocerca: true,
            datosutiles: true,
            eventos: true,
            direccion: true,
            recorrido: true,
            puntocercanos: true,
          }
        } */
    };
    //console.log(filter)
    //let urlFilter = this.qs.stringify(filter);
    return this.http.post(`${environment.baseUrl}clientes/control-flota/recorrido/${idequipo}`,filter);
  }

  /**
   * Genera el recorrido con los íconos para el mapa
   * @param res array de posiciones y eventos
   */
  recorridoIconMarker(res){
    //console.log(res)
    let markers: MovilRecorrido[] = [];
    var total = res['recorrido'].length;
    res['recorrido'].forEach((item: any, i) => {
      //console.log(item)
      let icono = 'flecha';
        //console.log(item.eventos)
      if (item.eventos && item.eventos.length > 0){
        if(item.eventos[0].cod_evento == 23 ||  // CONTACTO ON  23
          item.eventos[0].cod_evento == 24 ||   // CONTACTO OFF 24
          item.eventos[0].cod_evento == 16 ||   // EXCESO DE VELOCIDAD  16
          item.eventos[0].cod_evento == 21 ||   // BATERIA PRINCIPAL DESCONECTADA 21
          item.eventos[0].cod_evento == 22 ||   // BATERIA PRINCIPAL CONECTADA 22
          item.eventos[0].cod_evento == 25   // FRENADA BRUSCA 25
          ){
          icono = 'alerta';
        }
      }
      if (item.pointtype == "ParadasTiempo"){
        icono = (this.gtp.getDuration(item['duration']) != '00:00:00') ? "stop" : "flecha";
      }
      if (i == (total - 1)) { icono = 'auto'; }
      item.eventos = (item.eventos) ? item.eventos : false;
      item.cod_equipo_rastreo = res['equipoRastreo']['cod_equipo_rastreo'];
      item.des_equipo_ratreo = res['equipoRastreo']['des_equipo_ratreo'];
      //item.nro_vehiculo = res['equipoRastreo']['nro_vehiculo'];
      item.nro_vehiculo = res['nro_vehiculo'];

      var marker = new MovilRecorrido(item, icono);
      markers.push(marker);
    });
    return markers;
  }

  getLocation(lat, long) {
    return this.http.get(`${environment.baseUrl}georeferencia/location?latitud=${lat}&longitud=${long}`);
  }


  /**
   * Genera el reccorrido y eventos en formato de lista
   * @param res array de posiciones y eventos
   */
  recorridoResumenListados(res){
    //console.log(res)
    let recorrido: MovilRecorridoResumenLista[] = [];
    let eventos: MovilRecorridoResumenLista[] = [];
    res['recorrido'].forEach((item: any, i) => {

      let posData = {
        markerpos: i,
        latitud: item.latitud,
        longitud: item.longitud,
        eventos: []
      }

      if(item.eventos){
        item['eventos'].forEach(ev => {
            posData.eventos.push(new MovilRecorridoResumenLista(ev,posData));
            eventos.push(new MovilRecorridoResumenLista(ev,posData));
        });
      }

      recorrido.push( new MovilRecorridoResumenLista(item,posData) );

    });
    return {
      recorrido: recorrido,
      eventos: eventos
    };
  }

  flotaEnMapa(){
    this.removeMovilActivo();
    this.MapToolsService.setTipoMapa({ recorrido: false, verflota: true });
    this.callflotaMoviles();
  }

  getPositionRecorrido(){
    return this.posRecorrido.asObservable();
  }

  setPositionRecorrido(obj){
    //console.log(obj)
    return this.posRecorrido.next(obj);
  }

  sideResumen(resumen){
    let lista;
    if (resumen == 'eventos') { lista = ListaRecorridoEventosComponent; }
    if (resumen == 'posiciones') { lista = ListaRecorridoPosicionesComponent; }
    this.gtp.setRightSidebar({
      open: true,
      component: lista
    });
  }

}
